import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import RiskForm from '../../components/Risks/RiskForm';
import './RiskCreate.css';

const RiskCreate = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/app/risks');
  };

  return (
    <div className="risk-create-page">
      <div className="risk-create-header">
        <button onClick={handleBack} className="btn-back">
          <FiArrowLeft />
          Back to Risks
        </button>
      </div>
      <div className="risk-create-content">
        <RiskForm />
      </div>
    </div>
  );
};

export default RiskCreate;

